module.exports = __webpack_public_path__ + "img/carousel01.1c395317.png";